import { createEffect, createMemo, createSignal, onCleanup } from "solid-js";

import { State } from "./Controller";

const DELAY_MS = 10000;

const DOWN = [
  State.Connecting,
  State.Disconnected,
  State.Reconnecting,
  State.Offline,
];

/**
 * Majalis: true only once the client has been disconnected for a few seconds,
 * so quick reconnects (e.g. after switching apps on a phone) never show a bar.
 * A truly offline device is reported immediately.
 */
export function createSlowDisconnect(state: () => State) {
  const [slow, setSlow] = createSignal(false);
  const down = createMemo(() => DOWN.includes(state()));
  const offline = createMemo(() => state() === State.Offline);

  createEffect(() => {
    if (!down()) {
      setSlow(false);
      return;
    }
    if (offline()) {
      setSlow(true);
      return;
    }
    const timer = setTimeout(() => setSlow(true), DELAY_MS);
    onCleanup(() => clearTimeout(timer));
  });

  // Majalis: the reconnecting bar is disabled entirely
  void slow;
  return () => false;
}
